import React, { Suspense, useRef, useState } from "react";
import { AntDesign } from "@expo/vector-icons";
import CardStack, { Card } from "react-native-card-stack-swiper";
import { useBottomTabBarHeight } from "@react-navigation/bottom-tabs";
// prettier-ignore
import {  Modal, Pressable, ImageBackground, StyleSheet, View, Text } from "react-native";
// import { useWindowDims } from "../helpers/dimsHook.js";

import Svg, { G, Rect, Path, Defs, ClipPath } from "react-native-svg";

import colors from "../colors.js";

// Put the icons from figma here, via the svg to jsx plugin (https://github.com/SaraVieira/svg-to-jsx)

export function MagnifyingGlass(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 9a7 7 0 1112.041 4.856.998.998 0 00-.185.185A7 7 0 012 9zm12.618 7.032a9 9 0 111.414-1.414l3.675 3.675a1 1 0 01-1.414 1.414l-3.675-3.675z"
        fill={props.fill || colors.main_purple}
      />
    </Svg>
  );
}

export function Calendar(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM16 2v4M8 2v4M3 10h18"
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function PlayButton(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12 22.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z"
        stroke={props.stroke || colors.aquamarine}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10 8.5l6 4-6 4v-8z"
        stroke={props.stroke || colors.aquamarine}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function BackArrowCircle(props) {
  return (
    <Svg
      width={props.size || 30}
      height={props.size || 30}
      fill="none"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Rect
        width={30}
        height={30}
        rx={15}
        fill={colors.background_lighter_alpha}
      />
      <Path
        d="M22 15H8M15 22l-7-7 7-7"
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function BackArrow(props) {
  return (
    <Svg
      width={props.size || 30}
      height={props.size || 30}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M15 8H1M8 15L1 8l7-7"
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function PlusCircle(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10zM11 7v8M7 11h8"
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function Trashcan(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14z"
        stroke={props.stroke || colors.red}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function HeartFull(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M18.844 2.415a5.014 5.014 0 00-1.622-1.047 5.155 5.155 0 00-3.827 0 5.014 5.014 0 00-1.622 1.047l-.964.93-.963-.93A5.093 5.093 0 006.31 1a5.093 5.093 0 00-3.536 1.415 4.745 4.745 0 00-1.465 3.413c0 1.28.527 2.509 1.465 3.414l.963.93L10.81 17l7.072-6.828.963-.93a4.82 4.82 0 001.085-1.566 4.684 4.684 0 000-3.695 4.82 4.82 0 00-1.085-1.566z"
        fill="#8EFFD6"
        stroke={props.stroke || colors.aquamarine}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function HeartEmpty(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 25 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M19.185 2.915a5.015 5.015 0 00-1.623-1.047 5.155 5.155 0 00-3.827 0 5.015 5.015 0 00-1.622 1.047l-.964.93-.963-.93A5.092 5.092 0 006.65 1.5a5.093 5.093 0 00-3.536 1.415A4.745 4.745 0 001.65 6.328c0 1.28.526 2.509 1.464 3.414l.964.93 7.071 6.828 7.072-6.828.964-.93c.464-.448.832-.98 1.084-1.566a4.682 4.682 0 000-3.695 4.82 4.82 0 00-1.084-1.566v0z"
        stroke={props.stroke || colors.aquamarine}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function HeartCircle(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Rect
        width={16}
        height={16}
        rx={8}
        fill={props.fill || colors.aquamarine}
      />
      <Path
        d="M11.383 5.227a2.111 2.111 0 00-.683-.44 2.17 2.17 0 00-1.611 0 2.111 2.111 0 00-.683.44L8 5.62l-.406-.392a2.144 2.144 0 00-1.489-.595c-.558 0-1.093.214-1.488.595A1.998 1.998 0 004 6.665c0 .539.222 1.056.617 1.437l.405.392L8 11.368l2.977-2.874.406-.392a2.03 2.03 0 00.457-.66 1.972 1.972 0 000-1.555 2.03 2.03 0 00-.457-.66z"
        fill="#121018"
        stroke="#121018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function ThumbsDown(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill={props.fill || "none"}
      viewBox={props.viewBox || "0 0 25 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M13.99 10.9L10.537 19a2.54 2.54 0 01-1.832-.79 2.758 2.758 0 01-.76-1.91v-3.6H3.057c-.25.003-.498-.05-.727-.158a1.734 1.734 0 01-.596-.46 1.824 1.824 0 01-.355-.68 1.873 1.873 0 01-.05-.772l1.193-8.1c.062-.429.271-.82.589-1.101A1.686 1.686 0 014.248 1h9.743m0 9.9V1m0 9.9h2.306c.489.01.964-.17 1.335-.501.37-.332.612-.794.677-1.299V2.8a2.104 2.104 0 00-.677-1.299 1.947 1.947 0 00-1.335-.5H13.99"
        stroke={props.stroke || colors.red}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function ThumbsDownFull(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill={props.fill || colors.red}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M13.99 10.9L10.537 19a2.54 2.54 0 01-1.832-.79 2.758 2.758 0 01-.76-1.91v-3.6H3.057c-.25.003-.498-.05-.727-.158a1.734 1.734 0 01-.596-.46 1.824 1.824 0 01-.355-.68 1.873 1.873 0 01-.05-.772l1.193-8.1c.062-.429.271-.82.589-1.101A1.686 1.686 0 014.248 1h9.743m0 9.9V1m0 9.9h2.306c.489.01.964-.17 1.335-.501.37-.332.612-.794.677-1.299V2.8a2.104 2.104 0 00-.677-1.299 1.947 1.947 0 00-1.335-.5H13.99"
        stroke={props.stroke || colors.background_lighter}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function ThumbsDownCircle(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Rect y={0.16} width={16} height={16} rx={8} fill="#FF4A6B" />
      <Path
        d="M7.013 9.51v1.8c0 .358.144.701.402.954.257.253.606.396.97.396l1.829-4.05V3.66H5.056a.924.924 0 00-.603.214.896.896 0 00-.312.55l-.63 4.05a.886.886 0 00.213.726.914.914 0 00.7.31h2.589z"
        fill="#121018"
      />
      <Path
        d="M10.214 8.61l-1.83 4.05c-.363 0-.712-.143-.97-.396a1.34 1.34 0 01-.401-.954v-1.8H4.425a.927.927 0 01-.7-.31.896.896 0 01-.215-.725l.631-4.05a.896.896 0 01.312-.551.924.924 0 01.603-.214h5.158m0 4.95V3.66m0 4.95h1.22c.26.004.51-.085.707-.25.197-.167.324-.398.359-.65V4.56a1.035 1.035 0 00-.359-.65 1.067 1.067 0 00-.706-.25h-1.221"
        stroke="#121018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function BookmarkFull(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M14.34 17.652l-6.345-4.487-6.345 4.487V3.295c0-.476.19-.933.53-1.27.34-.336.802-.525 1.283-.525h9.064c.481 0 .942.19 1.282.526.34.336.531.793.531 1.269v14.357z"
        fill={props.fill || colors.yellow}
        stroke={props.stroke || colors.yellow}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        stroke={"black"}
        strokeWidth={1.5}
        strokeLinecap="round"
        d="M8.168 5.711v3.115M9.552 7.442H6.438"
      />
    </Svg>
  );
}

export function BookmarkEmpty(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 25 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M14 17.152l-6.345-4.487-6.346 4.487V2.795c0-.476.191-.933.531-1.27C2.18 1.19 2.641 1 3.122 1h9.065c.48 0 .942.19 1.282.526.34.336.531.793.531 1.269v14.357z"
        stroke={props.stroke || colors.yellow}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        stroke={props.stroke || colors.yellow}
        strokeWidth={1.5}
        strokeLinecap="round"
        d="M8.168 5.711v3.115M9.552 7.442H6.438"
      />
    </Svg>
  );
}

export function BookmarkCircle(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect
        y={0.66}
        width={16}
        height={16}
        rx={8}
        fill={props.fill || colors.yellow}
      />
      <Path
        d="M8 5.66v6M11 8.66H5"
        stroke={"#121018"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function Clock(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.963 6.027a4.415 4.415 0 118.83 0 4.415 4.415 0 01-8.83 0zM6.378.63a5.396 5.396 0 100 10.792 5.396 5.396 0 000-10.792zm.49 2.453a.49.49 0 00-.98 0v2.943a.49.49 0 00.27.439l1.963.98a.49.49 0 10.438-.877l-1.69-.845v-2.64z"
        fill={props.fill || colors.text_grey}
        fillOpacity={0.4}
      />
    </Svg>
  );
}

export function Edit(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z"
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function ShareIcon(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      style={props.style}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92z"
        fill={props.fill || colors.main_purple}
      />
    </Svg>
  );
}

export function AddFriend(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M8.5 11a4 4 0 100-8 4 4 0 000 8zM20 8v6M23 11h-6"
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function DownArrow(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M13 1L7 7 1 1"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

// this one is special, currently only used in the nav, it's not a square, so props.size won't work
export function Binoculars(props) {
  return (
    <Svg
      width={42}
      height={30}
      viewBox={props.viewBox || "0 0 25 25"}
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      fill="none"
    >
      <Path
        d="M10.656 0C8.75 0 7.226 1.377 6.902 3.169c-1.83.455-3.42 1.63-4.117 3.497h-.029l-2.06 5.708A6.6 6.6 0 000 15.304C0 18.991 3.048 22 6.781 22c3.364 0 6.166-2.441 6.69-5.62.527.512 1.24.837 2.029.837.789 0 1.502-.325 2.029-.837.523 3.179 3.326 5.62 6.69 5.62C27.952 22 31 18.99 31 15.304c0-.931-.194-1.823-.545-2.63l-2.21-6.098-.03-.029v-.031c-.707-1.693-2.275-2.881-4.117-3.348C23.773 1.379 22.25 0 20.344 0c-1.8 0-3.257 1.23-3.694 2.87h-2.3C13.912 1.23 12.454 0 10.655 0zm0 1.913c1.153 0 1.938.775 1.938 1.913v.957h5.812v-.957c0-1.138.785-1.913 1.938-1.913s1.937.775 1.937 1.913v.867l.878.09c1.44.149 2.68 1.14 3.24 2.42.01.02.02.04.028.06l.727 2.033a6.78 6.78 0 00-2.935-.688 6.786 6.786 0 00-6.268 4.184 2.903 2.903 0 00-1.056-.965 2.946 2.946 0 00-1.395-.349c-.487 0-.967.12-1.395.35-.428.23-.791.562-1.056.966a6.788 6.788 0 00-6.268-4.185 6.8 6.8 0 00-2.906.658l.727-1.944v-.029c.561-1.482 1.751-2.356 3.24-2.511l.877-.09v-.867c0-1.138.784-1.913 1.937-1.913zm-3.875 8.609c2.687 0 4.844 2.13 4.844 4.782 0 2.653-2.157 4.783-4.844 4.783-2.686 0-4.843-2.13-4.843-4.783 0-.677.169-1.3.424-1.884.015-.035.012-.082.029-.119a4.784 4.784 0 011.782-2.025 4.872 4.872 0 012.608-.754zm17.438 0c2.686 0 4.843 2.13 4.843 4.782 0 2.653-2.157 4.783-4.843 4.783-2.687 0-4.844-2.13-4.844-4.783 0-2.652 2.157-4.782 4.844-4.782zm-8.719 2.87c.546 0 .969.416.969.956s-.423.956-.969.956a.949.949 0 01-.969-.956c0-.54.423-.957.969-.957z"
        fill={props.fill || colors.main_purple}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.32 13.871A2.404 2.404 0 0024 13.45v-1.9a4.3 4.3 0 012.43.779c.87.626 1.52 1.661 1.52 3.171h-1.9c0-.89-.35-1.355-.73-1.629zM7.32 13.871A2.404 2.404 0 006 13.45v-1.9a4.3 4.3 0 012.43.779c.87.626 1.52 1.661 1.52 3.171h-1.9c0-.89-.35-1.355-.73-1.629z"
        fill={props.fill || colors.main_purple}
      />
    </Svg>
  );
}

export function Users(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      viewBox={props.viewBox || "0 0 25 25"}
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      fill="none"
    >
      <Path
        d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function Gear(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size || 25}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      viewBox={props.viewBox || "0 0 25 25"}
    >
      <G
        stroke={props.stroke || colors.main_purple}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <Path d="M12.214 15a3 3 0 100-6 3 3 0 000 6z" />
        <Path d="M19.614 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-1.415 3.417 1.998 1.998 0 01-1.415-.587l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1.08-1.51 1.65 1.65 0 00-1.82.33l-.06.06a1.998 1.998 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1h-.17a2 2 0 110-4h.09A1.65 1.65 0 004.814 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33h.08a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1h.17a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1v0z" />
      </G>
    </Svg>
  );
}

// Service Icons

// export function NetflixIcon(props) {
//   return (
//     <Svg
//       width={props.size || 25}
//       height={props.size || 25}
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//       {...props}
//     >
//       <Path
//         d="M0 .003l3.167 8.974v-.005l.25.706c1.393 3.94 2.14 6.051 2.143 6.054l.469.029c.77.031 1.726.12 2.45.205.167.021.31.026.32.021L5.37 6.261 3.753 1.693C3.563 1.148 3.37.603 3.175.06L3.154 0H.003L0 .003zm5.671.006l-.008 3.536-.005 3.539-.291-.823-.375 7.872c.37 1.045.567 1.602.57 1.605.003.002.214.018.466.028.774.034 1.727.12 2.454.209.166.018.312.025.32.018.01-.005.013-3.613.013-8.005L8.81.008H5.671zM0 .003v7.992c0 4.396.005 7.997.01 8.003.006.005.276-.021.605-.058.334-.042.669-.077 1.004-.107a39.92 39.92 0 011.5-.101c.034 0 .037-.18.042-3.386l.005-3.388.252.708.089.25.38-7.867-.127-.364L3.152.002 0 .003z"
//         fill={colors.text_grey}
//         fillOpacity={0.4}
//       />
//     </Svg>
//   );
// }

// export function HuluIcon(props) {
//   return (
//     <Svg
//       width={props.size || 25}
//       height={props.size || 25}
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//       {...props}
//     >
//       <Path
//         d="M7.619 4.911H5.22c-.47.008-.934.1-1.371.271V0H0v16h3.854V9.676a1.074 1.074 0 011.04-1.13h2.254c.574 0 1.045.46 1.057 1.036v6.377h3.842V9.024c0-2.933-1.496-4.096-3.922-4.096l-.506-.017z"
//         fill={colors.text_grey}
//         fillOpacity={0.4}
//       />
//     </Svg>
//   );
// }

// export function PeacockIcon(props) {
//   return (
//     <Svg
//       width={props.size || 25}
//       height={props.size || 25}
//       fill="none"
//       viewBox="0 0 20 20"
//       xmlns="http://www.w3.org/2000/svg"
//       {...props}
//     >
//       <Path
//         d="M2.048 9.592v1.746c0 1.14-.007 2.274.006 3.415 0 .219-.045.302-.284.296-.497-.02-.988-.013-1.486 0C.09 15.055 0 15.017 0 14.79c.006-3.202-.006-6.397.013-9.599.013-2.235 1.763-4.09 3.934-4.233 2.3-.141 4.244 1.43 4.567 3.698a4.172 4.172 0 01-2.468 4.4c-1.02.451-2.073.825-3.113 1.244-.117.045-.194.038-.278-.065-.175-.2-.368-.386-.607-.644zm0-2.963c-.007 0-.007 0 0 0-.007.567.006 1.14-.007 1.707-.006.213.058.225.24.155.936-.374 1.885-.728 2.815-1.109.82-.341 1.286-.979 1.409-1.855.18-1.314-.724-2.525-1.97-2.635-1.357-.122-2.436.838-2.48 2.236-.027.49-.007.998-.007 1.5zM12.198 14.98A1.02 1.02 0 0111.155 16a1.041 1.041 0 01-1.016-1.03c0-.569.462-1.03 1.038-1.03.58.006 1.027.461 1.021 1.04zM11.166 11.248c.573-.005 1.027.41 1.032.947.005.517-.449.943-1.005.954-.584.005-1.054-.427-1.054-.963.005-.502.475-.933 1.027-.938zM12.198 6.577a1.02 1.02 0 01-1.035 1.027 1.033 1.033 0 01-1.024-1.016 1.04 1.04 0 011.03-1.043 1.02 1.02 0 011.03 1.032zM11.19 0c.564.011 1.008.462 1.008 1.027-.005.576-.477 1.048-1.035 1.032A1.042 1.042 0 0110.14.983c.005-.537.493-.994 1.051-.983zM12.198 3.903c-.005.588-.448 1.013-1.049 1.008a1.018 1.018 0 01-1.01-1.03 1.044 1.044 0 011.049-1.03c.568-.005 1.015.458 1.01 1.052zM12.198 9.44a1 1 0 01-1.038 1.015 1.038 1.038 0 01-1.021-1.021c-.011-.554.478-1.033 1.038-1.038.575 0 1.021.456 1.021 1.043z"
//         fill={props.fill || colors.text_grey}
//         fillOpacity={0.4}
//       />
//     </Svg>
//   );
// }

export function HBO(props) {
  return (
    <Svg
      width={32}
      height={14}
      fill="none"
      viewBox={props.viewBox || "0 0 61 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <G opacity={0.4} clipPath="url(#prefix__clip0)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.768 24.89h-6.65v-9.488H6.812v9.488H0V.41h6.812v9.133h4.306V.41h6.65v24.48zm30.496.11c6.813 0 12.373-5.67 12.373-12.568C60.637 5.425 55.077 0 48.264 0 41.37 0 37.881 5.018 37.036 7.06c0-3.025-3.026-6.652-6.54-6.652H19.133V24.89h10.573c4.306 0 7.33-3.68 7.33-6.898C37.991 19.982 41.37 25 48.264 25zm-19.402-9.95c.98 0 1.772.955 1.772 2.045 0 1.145-.79 2.1-1.772 2.1h-3.38V15.05h3.38zm0-9.188c.98 0 1.772.955 1.772 2.045 0 1.09-.79 2.046-1.772 2.046h-3.38v-4.09h3.38zm4.468 6.57c.79-.055 2.072-.955 2.562-1.5-.19.655-.19 2.728 0 3.38-.545-.79-1.772-1.744-2.562-1.88zm8.722 0a6.211 6.211 0 016.252-6.215 6.197 6.197 0 016.173 6.308c-.05 3.418-2.811 6.15-6.213 6.15-3.433 0-6.212-2.78-6.212-6.243zm6.212 4.908c2.644 0 4.879-2.18 4.879-4.908 0-2.727-2.235-4.88-4.879-4.88-2.726 0-4.905 2.155-4.905 4.88a4.886 4.886 0 004.905 4.908z"
          fill="#fff"
        />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h60.637v25H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function HBOMax(props) {
  return (
    <Svg
      width={props.size || 25}
      height={props.size * 0.76 || 19}
      fill="none"
      viewBox={props.viewBox || "0 0 25 19"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#prefix__clip0)">
        <Path
          d="M24.996 6.849C24.892 2.372 21.735.002 17.853.002c-2.133 0-4.046.715-5.355 2.102C11.19.715 9.276 0 7.146 0 3.262 0 .102 2.373.002 6.856a.152.152 0 00-.002.03v10.207a1.699 1.699 0 001.697 1.698h1.602a.283.283 0 00.283-.283V6.886h.002C3.652 4.68 5.221 3.51 7.146 3.51c1.925 0 3.493 1.17 3.561 3.377h.002v10.207a1.699 1.699 0 001.697 1.698h1.602a.283.283 0 00.283-.283V6.886h.002c.068-2.207 1.637-3.377 3.562-3.377 1.924 0 3.493 1.17 3.56 3.377h.003v10.207a1.699 1.699 0 001.697 1.698h1.602a.281.281 0 00.262-.174.283.283 0 00.021-.109V6.886a.228.228 0 00-.004-.037z"
          fill="#fff"
          fillOpacity={0.4}
        />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h25v18.791H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function Disney(props) {
  return (
    <Svg
      width={props.size || 31}
      height={props.size * 0.81 || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 31 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#prefix__clip0)">
        <Path
          d="M11.59 14.485s-1.026.073-1.732.151c-.899.097-2.587.389-3.562.737-.292.104-.886.353-.938.653-.054.312.14.555.355.808.124.146.828.823 1.025.988.827.69 2.505 1.756 3.74 2.273.425.175 1.127.427 1.127.427s-.052-2-.043-3.97c.006-1.038.028-2.067.028-2.067zm18.816.796c.059.537-.08 1.553-.103 1.687-.044.308-.277 1.02-.316 1.108a12.62 12.62 0 01-.57 1.14c-.336.606-1.136 1.566-1.61 1.977-1.767 1.527-4.502 2.396-6.847 2.683-1.592.192-3.421.164-5.108-.148-.58-.106-1.444-.305-1.444-.305s.003.346-.025.588c-.013.111-.097.403-.143.497-.123.254-.325.384-.617.44-.354.066-.728.088-1.055-.051-.536-.226-.729-.728-.822-1.306-.075-.463-.155-1.267-.155-1.267s-.4-.19-.735-.357A19.024 19.024 0 018 20.217a35.855 35.855 0 01-1.477-1.238c-.628-.597-1.194-1.191-1.624-1.953-.335-.596-.431-1.124-.177-1.755.351-.879 1.612-1.54 2.474-1.918.633-.28 2.602-.922 3.42-1.042.386-.055.985-.162 1.022-.186a.233.233 0 00.037-.034c.018-.026.05-.897.044-1.215-.008-.313.232-2.369.309-2.804.04-.235.218-1.14.4-1.377.119-.161.329-.148.5-.043.938.584 1.223 2.607 1.293 3.636.042.627.063 1.57.063 1.57s1.076-.031 1.737-.013c.644.015 1.353.117 2.02.223.855.137 2.521.5 3.477.985.787.4 1.523 1.071 1.762 1.782.221.652.188 1.104-.15 1.692-.38.665-1.098 1.159-1.826 1.2-.216.012-1.032-.096-1.283-.29-.098-.078-.093-.218-.022-.312.027-.034.408-.236.633-.355.113-.06.206-.127.294-.207.187-.165.356-.346.337-.559-.026-.275-.318-.445-.596-.555-1.305-.518-3.91-.948-5.169-1.023-.493-.029-1.193-.054-1.193-.054l.148 6.953s.58.11 1.036.184c.262.04 1.372.14 1.667.147 2.247.06 4.754-.142 6.815-1.115.905-.426 1.736-.956 2.364-1.674.829-.95 1.263-2.25 1.148-3.608-.126-1.483-1.17-3.244-2.003-4.315-2.202-2.832-5.977-5.162-9.297-6.528-3.39-1.393-6.741-2.195-10.34-2.33-.927-.034-2.95.013-3.972.296-.146.041-.293.09-.429.12a1.194 1.194 0 00-.322.135c-.026.021-.051.05-.051.05s.063.035.123.06c.108.047.564.076.8.119.211.04.431.15.518.305.083.147.093.263-.006.386-.231.281-1.103.234-1.487.173-.4-.063-.896-.185-.987-.533-.106-.409.088-.81.298-1.18C.75 1.273 1.354.887 2.24.646 3.496.3 5.083.059 6.27.014c2.687-.102 5.23.368 7.832 1.158 1.49.45 3.44 1.206 4.867 1.894a38.164 38.164 0 013.545 1.996c.286.189 1.96 1.418 2.22 1.634a27.49 27.49 0 011.765 1.59c.993.986 2.23 2.495 2.83 3.693.144.287.256.57.443.902.064.114.338.795.384.992.045.195.111.48.12.492.014.105.14.69.13.916z"
          fill="#fff"
          fillOpacity={0.4}
        />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h30.42v25H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function Apple(props) {
  return (
    <Svg
      width={props.size || 21}
      height={props.size * 1.19 || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 21 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#prefix__clip0)" fill="#fff" fillOpacity={0.4}>
        <Path d="M15.117 0a5.636 5.636 0 01-1.29 4.01 4.597 4.597 0 01-3.707 1.756 5.288 5.288 0 011.319-3.848A5.526 5.526 0 0115.117 0zM10.267 7.201c.981 0 2.71-1.289 4.762-1.17v-.003a5.856 5.856 0 014.542 2.487 5.71 5.71 0 00-2.681 4.762 5.572 5.572 0 003.326 5.073 13.616 13.616 0 01-1.715 3.54c-1.025 1.598-2.168 3.035-3.81 3.072-1.64.037-2.197-.987-4.088-.987-1.89 0-2.403.967-4.058 1.024-1.656.057-2.902-1.697-3.942-3.169-2.14-3.096-3.751-8.762-1.553-12.565a6.027 6.027 0 015.128-3.14C7.79 6.095 9.285 7.2 10.267 7.2z" />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h20.216v25H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function Paramount(props) {
  return (
    <Svg
      width={props.size * 1.28 || 31}
      height={props.size || 24}
      fill="none"
      viewBox={props.viewBox || "0 0 32 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.25 20.402c-.157-.065-.414-.354.014-1.157l.994-2.076c.03-.063-.043-.141-.088-.088l-.869.873c-.411.43-1.108 1.635-1.243 1.858l-1.056 1.745a.142.142 0 01.129.211l-.965 1.62c-.236.402.187.683.245.59 1.516-2.442 2.398-2.247 2.398-2.247l.506-1.172a.117.117 0 00-.058-.154l-.007-.003zM15.697 0C7.028 0 0 7.023 0 15.686A15.604 15.604 0 003.069 25c.658-.284 1.024-.709 1.286-1.034l2.923-3.736a.595.595 0 01.233-.18l.44-.189 4.806-6.091.697-.545 1.432-1.992a.595.595 0 01.134-.134l.624-.454a.447.447 0 01.52-.005l.757.532c.402.282.729.66.95 1.098l3.036 5.33c.05.102.134.183.238.228.595.296.96.349 1.739 1.195.363.394 1.957 2.175 4.19 4.943.325.444.76.796 1.261 1.022a15.605 15.605 0 003.06-9.302C31.394 7.023 24.366 0 15.697 0zM4.233 16.55l-1.017-.33-.63.865v-1.069l-1.017-.33 1.018-.33v-1.07l.629.866 1.017-.33-.628.864.628.865zm-.24 3.498l-.332 1.017-.33-1.017H2.26l.866-.628-.331-1.017.865.629.866-.629-.33 1.017.865.628h-1.07zm.203-8.096l.331 1.016-.866-.628-.865.628.33-1.016-.865-.629h1.07l.33-1.016.331 1.016h1.07l-.866.629zm1.718-2.3l-.628-.865-1.018.33.629-.864-.63-.865 1.019.33.629-.865v1.07l1.017.329-1.018.33v1.07zM8.59 5.91l-.33 1.016-.33-1.016h-1.07l.865-.629-.33-1.016.865.628.865-.629-.33 1.018.865.628H8.59zm3.372-1.717l-.63.865V3.989l-1.017-.33 1.018-.33v-1.07l.629.865 1.017-.33-.629.865.629.865-1.017-.331zm4.271-.98l.331 1.017-.865-.629-.866.629.33-1.016-.865-.629h1.07l.33-1.016.33 1.016h1.07l-.865.628zm3.83.776v1.07l-.628-.866-1.018.33.63-.864-.63-.865 1.018.33.629-.865v1.07l1.018.33-1.018.33zm7.1 10.832l1.017.33.629-.864v1.069l1.017.33-1.017.33v1.07l-.63-.865-1.017.33.63-.865-.63-.865zm-4.026-7.895l-.33-1.016h-1.07l.865-.629-.33-1.016.865.628.865-.628-.33 1.016.866.629h-1.07l-.331 1.016zm2.345 2.726V8.583l-1.018-.33 1.018-.33v-1.07l.628.865 1.018-.33-.628.865.628.865-1.018-.33-.628.864zm1.921 1.671l.331-1.016.331 1.016h1.07l-.865.629.33 1.017-.866-.629-.865.629.331-1.017-.866-.629h1.07zm.662 8.725l-.33 1.017-.332-1.017h-1.07l.867-.628-.331-1.017.865.629.866-.629-.33 1.017.864.628h-1.069zm-6.68 4.703c.075-.11.197-.41-.033-.966l-.694-1.867c-.095-.238.112-.383.25-.226 0 0 1.313 1.512 1.652 2.144l.648 1.074c.557.036 2.094.078 3.573.078a4.194 4.194 0 01-.412-.475c-2.524-3.129-4.125-4.869-4.141-4.886-.512-.556-.749-.662-1.139-.84-.056-.026-.118-.053-.18-.084v.475a.059.059 0 01-.113.03l-3.712-6.516-.01-.02a2.088 2.088 0 00-.665-.77l-.362-.254-1.77 4.083a.383.383 0 01.351.535l-1.636 3.782h1.502c.58 0 1.155.113 1.693.333l.395.162S15.387 23 15.387 24.292c.002.235.035.469.098.695h2.753l-.128-.775c1.08.241 2.173.422 3.273.54z"
        fill="#fff"
        fillOpacity={0.4}
      />
    </Svg>
  );
}

export function Hulu(props) {
  return (
    <Svg
      width={props.size * 0.76 || 19}
      height={props.size || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 19 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#prefix__clip0)">
        <Path
          d="M11.937 7.788H8.06c-1.363 0-2.03.364-2.03.364V0H0v25h6.03V14.91c0-.88.726-1.607 1.605-1.607h3.514c.879 0 1.606.727 1.606 1.606V25h6.03V14.121c0-4.576-3.03-6.333-6.848-6.333z"
          fill="#fff"
          fillOpacity={0.4}
        />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h18.784v25H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function Netflix(props) {
  return (
    <Svg
      width={props.size * 0.56 || 14}
      height={props.size || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 14 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#prefix__clip0)">
        <Path
          d="M0 .005l4.961 14.023v-.008l.392 1.103c2.183 6.157 3.354 9.457 3.358 9.461l.734.045c1.208.049 2.706.187 3.84.32.26.034.486.041.502.034l-5.373-15.2L5.88 2.646c-.297-.852-.6-1.703-.905-2.552L4.942 0H.005L0 .005zm8.886.008L8.874 5.54l-.008 5.53-.457-1.286-.588 12.302c.58 1.632.89 2.503.894 2.507.005.004.335.028.73.044 1.212.053 2.706.188 3.844.326.26.028.49.04.502.028.016-.008.02-5.644.02-12.51L13.804.014H8.886zM0 .005v12.489c0 6.87.008 12.497.016 12.505.01.008.433-.033.947-.09a42.843 42.843 0 011.574-.167 62.557 62.557 0 012.35-.159c.054 0 .058-.28.066-5.29l.007-5.294.396 1.107.139.39.595-12.293-.2-.57-.95-2.63L0 .006z"
          fill="#fff"
          fillOpacity={0.4}
        />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h13.811v25H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function Amazon(props) {
  return (
    <Svg
      width={props.size * 1.04 || 26}
      height={props.size || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 27 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <G opacity={0.4} clipPath="url(#prefix__clip0)" fill="#fff">
        <Path d="M1.004 9.118c-.08 0-.144-.017-.179-.052-.04-.034-.057-.098-.057-.184V2.498c0-.093.017-.15.057-.185.04-.04.098-.058.179-.058h.686c.145 0 .237.07.266.208l.069.248c.19-.184.42-.334.692-.438.271-.11.548-.162.83-.162.618 0 1.108.225 1.471.68.363.456.542 1.068.542 1.84 0 .531-.092.992-.265 1.39a2.204 2.204 0 01-.727.917 1.8 1.8 0 01-1.055.323c-.26 0-.513-.04-.744-.127a1.734 1.734 0 01-.606-.346v2.094c0 .086-.017.15-.052.184-.034.035-.098.052-.184.052h-.923zm2.1-2.918c.357 0 .622-.121.79-.363.167-.243.253-.623.253-1.148 0-.53-.08-.917-.248-1.159-.167-.242-.432-.363-.796-.363a1.82 1.82 0 00-.94.26v2.52c.283.167.594.253.94.253zM6.727 7.145c-.081 0-.144-.017-.18-.057-.04-.04-.057-.098-.057-.18v-4.41c0-.093.018-.15.058-.185.04-.035.098-.052.179-.052h.692c.144 0 .236.07.265.207l.127.52c.254-.283.496-.48.72-.6a1.5 1.5 0 01.722-.179h.132c.087 0 .156.017.19.052.041.034.058.098.058.184v.802c0 .08-.017.144-.051.179-.035.04-.098.057-.185.057-.046 0-.104-.005-.173-.011a3.205 3.205 0 00-.265-.012c-.145 0-.323.023-.537.064-.207.04-.392.092-.536.156v3.217c0 .081-.017.145-.052.18-.035.04-.098.057-.185.057l-.922.011zM10.948 1.5c-.242 0-.438-.07-.582-.202-.144-.133-.22-.318-.22-.548 0-.231.075-.41.22-.548.144-.133.34-.202.582-.202.242 0 .438.07.583.202.144.132.219.317.219.548 0 .23-.075.41-.22.548-.143.132-.34.201-.582.201zm-.461 5.645c-.081 0-.144-.017-.179-.058-.04-.04-.058-.098-.058-.178V2.497c0-.092.018-.15.058-.185.04-.034.098-.051.179-.051h.917c.086 0 .15.017.184.051.035.035.052.099.052.185v4.412c0 .08-.017.144-.052.178-.034.04-.098.058-.184.058h-.917zM13.053 7.146c-.08 0-.144-.017-.179-.058-.04-.04-.058-.098-.058-.179V2.498c0-.092.018-.15.058-.185.04-.034.098-.052.179-.052h.692c.144 0 .236.07.265.208l.075.26c.34-.225.64-.381.917-.473a2.57 2.57 0 01.836-.139c.577 0 .981.202 1.217.611.323-.219.635-.374.918-.467.282-.092.582-.144.888-.144.444 0 .796.127 1.038.375.248.248.369.6.369 1.044v3.38c0 .08-.017.143-.052.178-.035.04-.098.058-.185.058h-.917c-.08 0-.144-.018-.178-.058a.265.265 0 01-.058-.179v-3.08c0-.432-.196-.65-.583-.65-.346-.001-.692.08-1.044.247v3.477c0 .081-.017.145-.051.18-.035.04-.098.057-.185.057h-.917c-.08 0-.144-.017-.179-.058-.04-.04-.057-.098-.057-.179V3.836c0-.433-.197-.652-.583-.652-.357 0-.71.087-1.055.26v3.465c0 .081-.018.145-.052.18-.035.04-.098.057-.185.057h-.934zM23.555 7.3c-.779 0-1.373-.184-1.852-.669-.311-.317-.605-.91-.605-1.92 0-.819.26-1.442.68-1.892.421-.455 1.067-.663 1.673-.663.761 0 1.21.173 1.557.52.058.057.404.414.404.991 0 .196.005.404-.133.692-.092.196-.23.317-.271.352-.565.519-1.673.484-2.047.461l-.606-.092c.04.421.156.75.415.94.242.179.508.248 1.05.248.27 0 .634-.052 1.101-.179.024-.006.075-.017.093-.023.011 0 .057-.006.086.006.052.017.11.063.11.208v.438c0 .104-.012.173-.04.213a.4.4 0 01-.168.115c-.49.168-.94.254-1.447.254zm.582-3.587c0-.467-.329-.6-.732-.6a.962.962 0 00-.704.289c-.173.19-.277.473-.323.836 0 0 .715.133 1.234.046.271-.046.525-.196.525-.57zM17.332 17.109c-.779 0-1.373-.185-1.851-.67-.312-.316-.606-.91-.606-1.92 0-.818.26-1.441.68-1.891.422-.456 1.067-.663 1.673-.663.761 0 1.211.173 1.552.519.057.057.403.415.403.992 0 .196.006.403-.132.692-.093.196-.231.317-.271.352-.566.519-1.673.484-2.048.46l-.605-.091c.04.42.155.75.415.94.242.178.507.248 1.05.248.27 0 .634-.052 1.101-.18l.092-.022c.012 0 .058-.006.087.005.052.018.11.064.11.208v.438c0 .104-.012.173-.041.214a.4.4 0 01-.167.115 4.243 4.243 0 01-1.442.254zm.582-3.587c0-.467-.328-.6-.732-.6a.962.962 0 00-.704.288c-.173.19-.277.473-.323.837 0 0 .715.132 1.235.046.27-.046.524-.196.524-.571zM3.403 16.955a.403.403 0 01-.156-.023.268.268 0 01-.104-.075.514.514 0 01-.08-.15l-1.638-4.262c-.018-.052-.035-.098-.046-.133a.387.387 0 01-.018-.103c0-.098.064-.144.19-.144h.958c.104 0 .179.017.225.057.046.04.086.104.11.19l.986 3.391.998-3.39a.334.334 0 01.11-.19.376.376 0 01.224-.058h.929c.126 0 .19.046.19.144 0 .034-.006.069-.017.103-.012.04-.03.081-.047.133L4.58 16.707a.514.514 0 01-.081.15.237.237 0 01-.098.075.417.417 0 01-.162.023h-.836zM7.579 11.308c-.242 0-.438-.07-.582-.202-.15-.133-.22-.317-.22-.548 0-.23.075-.41.22-.548.144-.132.34-.201.582-.201.242 0 .438.069.583.201.144.133.219.318.219.548a.72.72 0 01-.22.548c-.144.133-.34.202-.582.202zm-.461 5.646c-.081 0-.145-.018-.185-.058-.04-.04-.058-.098-.058-.179v-4.411c0-.093.018-.15.058-.185.04-.035.098-.052.185-.052h.917c.086 0 .15.017.184.052.035.035.052.098.052.185v4.411c0 .081-.017.144-.052.179-.034.04-.098.058-.184.058h-.917zM11.206 17.064c-.415 0-.779-.11-1.084-.323a2.045 2.045 0 01-.704-.888c-.161-.38-.242-.819-.242-1.314 0-.79.19-1.425.565-1.898.375-.473.877-.715 1.494-.715.502 0 .94.144 1.309.433v-2.244c0-.092.017-.15.058-.184.04-.035.098-.052.184-.052h.917c.093 0 .15.017.185.052.034.034.052.098.052.184v6.603c0 .081-.018.145-.052.18-.035.04-.098.057-.185.057h-.767a.328.328 0 01-.179-.046.293.293 0 01-.092-.162l-.058-.219a2.01 2.01 0 01-1.401.536zm.456-1.055c.305 0 .6-.092.882-.265v-2.532a1.83 1.83 0 00-.946-.236c-.34 0-.588.127-.755.38-.168.254-.248.635-.248 1.142 0 .513.086.888.265 1.142.167.248.438.369.802.369zM22.268 17.099c-.761 0-1.355-.231-1.782-.687-.427-.455-.64-1.09-.64-1.908 0-.814.213-1.442.64-1.898.427-.455 1.02-.686 1.782-.686.761 0 1.355.23 1.782.686.427.456.64 1.09.64 1.898 0 .818-.213 1.453-.64 1.908-.427.462-1.02.687-1.782.687zm0-1.073c.669 0 1.003-.508 1.003-1.522 0-1.01-.334-1.511-1.003-1.511-.669 0-1.003.507-1.003 1.516 0 1.01.334 1.517 1.003 1.517z" />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 19.401v.081a.37.37 0 00.11.202C3.524 23.006 8.034 25 13.046 25c3.576 0 7.728-1.211 10.589-3.49.473-.38.069-.945-.416-.72-3.212 1.47-6.695 2.18-9.873 2.18-4.706 0-9.263-1.39-12.942-3.702a.344.344 0 00-.185-.058.21.21 0 00-.219.19z"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.277 19.76a.388.388 0 00-.168.242v.046c.012.087.093.144.237.127.923-.121 2.976-.38 3.345.121.37.502-.41 2.578-.75 3.506-.104.277.121.392.358.179 1.54-1.378 1.932-4.267 1.62-4.688-.15-.202-.853-.387-1.73-.387-.94 0-2.064.214-2.912.854z"
        />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h26.018v25H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function Peacock(props) {
  return (
    <Svg
      width={props.size * 0.8 || 19}
      height={props.size || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 20 25"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#prefix__clip0)" fill="#fff" fillOpacity={0.4}>
        <Path d="M3.197 14.987v2.728c0 1.782-.01 3.553.01 5.335 0 .342-.07.473-.444.463-.776-.03-1.543-.02-2.32 0-.302.01-.443-.05-.443-.403.01-5.002-.01-9.995.02-14.998.02-3.493 2.753-6.392 6.142-6.614 3.59-.221 6.626 2.235 7.13 5.778.404 2.86-1.13 5.668-3.852 6.876-1.594.704-3.238 1.288-4.861 1.942-.182.07-.303.06-.434-.1-.272-.313-.575-.604-.948-1.007zm0-4.63c-.01 0-.01 0 0 0-.01.885.01 1.781-.01 2.667-.01.332.09.352.373.242 1.462-.584 2.945-1.138 4.397-1.732 1.28-.533 2.007-1.53 2.199-2.899.282-2.053-1.13-3.946-3.076-4.117-2.118-.191-3.802 1.309-3.873 3.493-.04.765-.01 1.56-.01 2.346zM19.043 23.409A1.594 1.594 0 0117.415 25a1.627 1.627 0 01-1.587-1.608c0-.89.721-1.609 1.62-1.609.908.009 1.604.72 1.595 1.626zM17.431 17.576c.895-.008 1.604.643 1.612 1.481.009.808-.7 1.474-1.57 1.49-.91.007-1.645-.667-1.645-1.505.009-.784.743-1.458 1.604-1.466zM19.044 10.277c0 .9-.711 1.605-1.617 1.605a1.614 1.614 0 01-1.599-1.588c-.016-.883.72-1.621 1.608-1.63a1.594 1.594 0 011.608 1.613zM17.47 0c.88.017 1.574.722 1.574 1.605-.009.9-.745 1.638-1.617 1.612-.922-.034-1.615-.755-1.599-1.68.009-.84.77-1.554 1.642-1.537zM19.043 6.098c-.008.92-.699 1.583-1.637 1.575a1.59 1.59 0 01-1.578-1.609 1.631 1.631 0 011.638-1.609c.887-.008 1.586.715 1.577 1.643zM19.044 14.75c0 .908-.705 1.604-1.62 1.587a1.621 1.621 0 01-1.596-1.596c-.017-.866.747-1.613 1.62-1.622.9 0 1.596.713 1.596 1.63z" />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h19.045v25H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export function YouTube(props) {
  return (
    <Svg
      width={props.size || 36}
      height={props.size * 0.69 || 25}
      fill="none"
      viewBox={props.viewBox || "0 0 25 36"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.81.765a4.473 4.473 0 013.145 3.147c.764 2.794.735 8.617.735 8.617s0 5.794-.735 8.589a4.473 4.473 0 01-3.146 3.147C29.017 25 17.845 25 17.845 25s-11.142 0-13.964-.765a4.473 4.473 0 01-3.146-3.147C0 18.323 0 12.5 0 12.5s0-5.794.735-8.588c.412-1.53 1.646-2.765 3.146-3.177C6.674 0 17.845 0 17.845 0s11.172 0 13.964.765zm-8.23 11.734l-9.29 5.353V7.146l9.29 5.353z"
        fill="#fff"
        fillOpacity={0.4}
      />
    </Svg>
  );
}
